<script lang="ts" setup>
import { computed } from 'vue'
import CountUp from './CountUp.vue'
import { getRunStatusBadgeClass, type CountChip } from '../utils/runFormatters'

const props = withDefaults(
  defineProps<{
    chips: CountChip[]
    size?: 'sm' | 'md'
    /** Drop zero-count chips (default true) so trivial tallies don't render noise. */
    hideZero?: boolean
    /** Whether these counts are still being added to. A finished service's numbers are what it came
     *  to, so they are printed; a running one's are progress, so they count up to each new figure. */
    climbing?: boolean
  }>(),
  { size: 'md', hideZero: true, climbing: false }
)

// Hidden rather than dropped. A chip filtered out while its count is zero would be created holding the
// first number that arrives, and a number that was already there when it appeared cannot count up to
// itself — so the one step a reader most wants to see, nothing becoming something, is the one that
// would land in a single frame.
const isShown = (chip: CountChip) => !props.hideZero || chip.count > 0
</script>

<template>
  <div
    v-if="chips.length"
    class="d-inline-flex flex-wrap align-items-center gap-1"
    :class="{ small: size === 'sm' }"
  >
    <span
      v-for="chip in chips"
      v-show="isShown(chip)"
      :key="chip.status"
      class="badge rounded-pill"
      :class="getRunStatusBadgeClass(chip.status)"
      :title="chip.label"
    >
      <i v-if="chip.icon" class="bi me-1" :class="chip.icon"></i><CountUp :value="chip.count" :climbing="climbing" />
    </span>
  </div>
</template>
